import { Config } from '../config/config';
import { ILogger, LogActionType } from './common';

let prodLogger: ILogger = null;

const wrap = (localLogger: ILogger, globalLogger: ILogger): ILogger => {
    return {
        exceptionAsync(error: Error) {
            localLogger.exceptionAsync(error);
            globalLogger.exceptionAsync(error);
        },

        logAsync(actionType: LogActionType, data: object) {
            localLogger.logAsync(actionType, data);
            globalLogger.logAsync(actionType, data);
        },

        errorAsync(data: object) {
            localLogger.errorAsync(data);
            globalLogger.errorAsync(data);
        },

        errorTypedAsync(errorType: string, data?: object) {
            localLogger.errorTypedAsync(errorType, data);
            globalLogger.errorTypedAsync(errorType, data);
        },

        infoAsync(data: object) {
            localLogger.infoAsync(data);
            globalLogger.infoAsync(data);
        },

        infoTypedAsync(infoType: string, data?: object) {
            localLogger.infoTypedAsync(infoType, data);
            globalLogger.infoTypedAsync(infoType, data);
        }
    };
};

export { LogActionType };
export type { ILogger };
export const enableLocalLogger = () => Config.isForDevelopment;

export const logging = {
    enableProdLogger(instance: ILogger) {
        prodLogger = instance;

        return {
            enableLocalLogger(localInstance: ILogger) {
                prodLogger = wrap(localInstance, prodLogger);
            }
        };
    }
};

export const logger = (): ILogger => prodLogger;
